// extracted by mini-css-extract-plugin
export default {"sortable":"Sorting_sortable__ZQ+5i"};